export default __webpack_public_path__ + "assets/img/beeline.64d8d9a.svg";